<template>
    <div class="feature">
      <div class="banner-top">
        <div class="banner-box"></div>
        <div class="banner-desc">小众、细分领域的原创研究与专业内参</div>
      </div>
      <div class="feature-box">
        <el-row :gutter="20">
<!--          <el-col :xs='24' :md="6" :lg="{span:'4-8'}" :sm="12" v-for="(item, i) in menuList" :key="i">-->
          <el-col :span='4' v-for="(item, i) in menuList" :key="i">
            <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="five-tooltip">
            <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
              <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
            </div>
            </el-tooltip>
          </el-col>
        </el-row>

        <div class="list" v-show="currentIndex === ''">
          <div class="list-box" v-for="(item,i) in itemList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 3">
          <div class="list-box" v-for="(item,i) in itemLcList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getFeatureLcMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 5">
<!--          <div style="margin-bottom: 10px;"><img src="../assets/images/升级页面.jpg" alt=""></div>-->
          <div class="list-box" v-for="(item,i) in itemETFList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getFeatureETFMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 4">
          <div style="margin-bottom: 10px;"><img src="../assets/images/升级页面.jpg" alt=""></div>
          <div class="list-box" v-for="(item,i) in itemKzzList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getFeatureKzzMore">点击加载更多...</div>
            </div>
          </div>
        </div>
        <div class="list" v-show="currentIndex === 2  ">
          <div class="tips">因国庆长假，港股通（南向）自9月29日（星期四）至10月7日（星期五）休市，另10月8日(星期六)、10月9日(星期日)为周末休市。故在此期间，港股通内参暂停发刊，10月10日（星期一）重启。</div>
          <div class="list-box" v-for="(item,i) in itemGgList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getFeatureGgMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="article-list" v-show="currentIndex === 6">
          <div class="zx-list">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="最新" name="eight">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item,i) in itemLatestList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="recommendList">
                          <li v-for="(item, i) in itemTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getLatestMore();getLatestTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="配置" name="third">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemPzList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="sx-recommendList">
                          <li v-for="(item, i) in itemPzTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getPzMore();getPzTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="行情" name="fourth">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemHqList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="zq-recommendList">
                          <li v-for="(item, i) in itemHqTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getHqMore();getHqTjMore()">点击加载更多...</div>
                  </div>
                </div>

              </el-tab-pane>
              <el-tab-pane label="选基" name="five">
                <div class="main-content">
                  <div class="left">
                    <div class="list-box" v-for="(item, i) in itemXjList" :key="i">
                      <div class="img-box">
                        <img class="thumb-img" :src="item.img" alt="">
                      </div>
                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                        <div class="article_title">
                          <div class="title">{{ item.title }}</div>
                          <div class="list-content">{{ item.desc }}</div>
                          <div class="list-bottom">
                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="right">
                    <div class="recommend">
                      <div class="top">
                        <div class="title">最新推荐</div>
                      </div>
                      <div class="recommend-list">
                        <ul id="yp-recommendList">
                          <li v-for="(item, i) in itemXjTjList" :key="i">
                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=feature'">
                              <img :src="item.img">
                              <div class="recommend-title">{{ item.title }}</div>
                              <div class="recommend-bottom">
                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div class="cursorPointer">
                    <div @click="getXjMore();getXjTjMore()">点击加载更多...</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </div>

        <div class="list" v-show="currentIndex === 0">
          <div class="list-box" v-for="(item,i) in itemAgList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getAgMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 1">
          <div class="list-box" v-for="(item,i) in itemRzRqList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getRzRqMore">点击加载更多...</div>
            </div>
          </div>
        </div>

      </div>
      <div class="back-top" @click="backTop" v-show="btnFlag">
        <img src="../assets/images/return_top.png" alt="" srcset="">
      </div>
    </div>
</template>

<script>
import {Ag, RzRq, FeatureAll, FeatureLcList, FeatureETFList, FeatureKzzList, FeatureGgList, LatestList, FundTjList, PzList, PzTjList,HqList, HqTjList, XjList, XjTjList } from "@/api/news";
export default {
  name: "Feature",
  data() {
    return {
      currentIndex:'',
      activeName: 'eight',
      currentTab:'eight',
      itemList: [],
      itemAgList: [],
      itemRzRqList: [],
      itemLcList: [],
      itemETFList: [],
      itemKzzList: [],
      itemGgList: [],
      itemLatestList: [],
      itemTjList: [],
      itemPzList: [],
      itemPzTjList: [],
      itemHqList: [],
      itemHqTjList: [],
      itemXjList: [],
      itemXjTjList: [],
      btnFlag: false,
      token: window.localStorage.getItem('token'),
      page: 1,
      agPage:1,
      rzPage:1,
      menuList:[
        {
          imgUrl: require('../assets/images/icon_每日A股2.png'),
          imgUrls: require('../assets/images/icon_每日A股1.png'),
          txt: '每日A股',
          desc: '从策略、政策、行业、个股、日历及资金等多维度，全方位展示市场运行脉络，及时解读重大政策及行业事件（更新频率：交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_融资融券2.png'),
          imgUrls: require('../assets/images/icon_融资融券1.png'),
          txt: '融资融券',
          desc: '专业研究背书两融标的，及时信息把握两融投资机会，丰富数据把脉两融市场温度（更新频率：交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_港股2.png'),
          imgUrls: require('../assets/images/icon_港股1.png'),
          txt: '港股通',
          desc: '分享国际投行对于港股市场的最新研究与结论，港股通个股数据以及重大事件对AH股的联动影响（更新频率：港股通交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_理财2.png'),
          imgUrls: require('../assets/images/icon_理财1.png'),
          txt: '理财',
          desc: '覆盖大类资产（股票、债券、货币、QDII等）基金走势图，理财产品动态、行业动态、重点关注方向及下月市场展望（更新频率：每周日20:00前/次月上旬）'
        },
        {
          imgUrl: require('../assets/images/icon_可转债2.png'),
          imgUrls: require('../assets/images/icon_可转债1.png'),
          txt: '可转债',
          desc: '全面、及时、高效的可转债投资专属内参！覆盖打新、强赎、热点以及投教等维度。解读市场热点，挖掘潜力机会。（更新频率：周一、周三盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_ETF2.png'),
          imgUrls: require('../assets/images/icon_ETF1.png'),
          txt: 'ETF',
          desc: '全面、及时、高效的ETF投资专属内参！覆盖策略、热门ETF、潜力ETF、行情以及热门资讯等维度。解读市场热点，挖掘潜力基会。（更新频率：周一、周三盘前）'
        },
        // {
        //   imgUrl: require('../assets/images/icon_基金2.png'),
        //   imgUrls: require('../assets/images/icon_基金1.png'),
        //   txt: '基金',
        //   desc: '涵盖基金投顾的全方位需求：如何配置，行情解读和基金选择'
        // },
      ]
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getFeatureAllList()
    this.getFeatureLcList()
    this.getFeatureETFList()
    this.getFeatureKzzList()
    this.getFeatureGgList()
    this.getLatestList()
    this.getTjList()
    this.getPzList()
    this.getPzTjList()
    this.getHqList()
    this.getHqTjList()
    this.getXjList()
    this.getXjTjList()
    this.getAgList()
    this.getRzRqList()
  },
  mounted() {
    this.toJump()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const currentFe = this.currentTab;
        // console.log(currentFe);
        if(currentFe ==='first'){
          this.currentIndex = 0
        }else if(currentFe ==='second' || currentFe === 'third' || currentFe === 'fourth'  || currentFe === 'five'){
          this.currentIndex = 1
        }else if(currentFe === 'six'){
          this.currentIndex = 2
        } else if(currentFe === 'seven'){
          this.currentIndex = 3
        }else if(currentFe === 'eight'){
          this.currentIndex = 6
        }else if(currentFe === 'nine'){
          this.currentIndex = 4
        }else if(currentFe === 'ten'){
          this.currentIndex = 5
        }
      }
    },
    selectMenu(index) {
      this.currentIndex = index
      // if(index === 4 ){
      //   this.$router.push({
      //     query: {
      //       activeName: 'eight',
      //       currentTab: 'eight',
      //     }
      //   })
      // }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    getAgList() {
      Ag({id: '11fkoitz5iv', page: this.agPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemAgList = this.itemAgList.concat(response.data.data)
        }
      });
    },
    getRzRqList() {
      RzRq({id: '18f8y0qbqy7', page: this.rzPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemRzRqList = this.itemRzRqList.concat(response.data.data)
        }
      });
    },
    getFeatureAllList() {
      FeatureAll({id: '2yxepw206l', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getFeatureLcList() {
      FeatureLcList({id: '19ep1dxcimb', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemLcList = this.itemLcList.concat(response.data.data)
        }
      });
    },
    getFeatureETFList() {
      FeatureETFList({id: 'i19n0mu1y5', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemETFList = this.itemETFList.concat(response.data.data)
        }
      });
    },
    getFeatureKzzList() {
      FeatureKzzList({id: '1vrccznpg32', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemKzzList = this.itemKzzList.concat(response.data.data)
        }
      });
    },
    getFeatureGgList() {
      FeatureGgList({id: 'esaj3z75b2', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemGgList = this.itemGgList.concat(response.data.data)
        }
      });
    },
    getLatestList() {
      LatestList({id: 'sh08amfu4o', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemLatestList = this.itemLatestList.concat(response.data.data)
        }
      });
    },
    getPzList() {
      PzList({id: '28usek0t2yv', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemPzList = this.itemPzList.concat(response.data.data)
        }
      });
    },
    getHqList() {
      HqList({id: 'bmv15217pm', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemHqList = this.itemHqList.concat(response.data.data)
        }
      });
    },
    getXjList() {
      XjList({id: 'l35j1vklkl', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemXjList = this.itemXjList.concat(response.data.data)
        }
      });
    },
    getTjList() {
      FundTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjList = this.itemTjList.concat(response.data.data)
        }
      });
    },
    getPzTjList() {
      PzTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemPzTjList = this.itemPzTjList.concat(response.data.data)
        }
      });
    },
    getHqTjList() {
      HqTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemHqTjList = this.itemHqTjList.concat(response.data.data)
        }
      });
    },
    getXjTjList() {
      XjTjList({id:'2bwoal5oysw',limit: 3, page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemXjTjList = this.itemXjTjList.concat(response.data.data)
        }
      });
    },
    getAgMore() {
      this.agPage++;
      this.getAgList()
    },
    getRzRqMore() {
      this.rzPage++;
      this.getRzRqList()
    },
    getMore() {
      this.page++;
      this.getFeatureAllList()
    },
    getFeatureLcMore() {
      this.page++;
      this.getFeatureLcList()
    },
    getFeatureETFMore() {
      this.page++;
      this.getFeatureETFList()
    },
    getFeatureKzzMore() {
      this.page++;
      this.getFeatureKzzList()
    },
    getFeatureGgMore() {
      this.page++;
      this.getFeatureGgList()
    },
    getLatestMore() {
      this.page++;
      this.getLatestList()
    },
    getLatestTjMore() {
      this.page++;
      this.getTjList()
    },
    getPzMore() {
      this.page++;
      this.getPzList()
    },
    getPzTjMore() {
      this.page++;
      this.getPzTjList()
    },
    getHqMore() {
      this.page++;
      this.getHqList()
    },
    getHqTjMore() {
      this.page++;
      this.getHqTjList()
    },
    getXjMore() {
      this.page++;
      this.getXjList()
    },
    getXjTjMore() {
      this.page++;
      this.getXjTjList()
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>

<style scoped>
.feature {
  background-color: #F5F7FA;
}

.tips{
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  text-align: center;
  color: red;
  display: none;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
}

.feature-box {
  width: 1200px;
  margin: -30px auto 0;
}
>>>.el-col-md-6 {
  width: 20%;
}
.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 30px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}


.zx-list {
  width: 1200px;
  margin-top: 10px;
  display: flex;
}

.main-content{
  display: flex;
  width: 1200px;
}

.zx-list .left {
  width: 900px;
  margin-right: 10px;
}

.zx-list .right {
  width: 300px;
  margin-top: -44px;
}

.zx-list .right .recommend .recommend-list {
  padding: 30px 0;
  background: #fff;
  margin-top: 14px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.zx-list .right .recommend .recommend-list ul {
  width: 260px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li:not(:last-child) {
  border-bottom: 1px solid #cdcdcd;
  margin-bottom: 30px;
}

.zx-list .right .recommend .recommend-list li img {
  width: 260px;
  height: 120px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li .recommend-title {
  margin: 15px 0;
  font-size: 14px;
  color: #313131;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.zx-list .right .recommend .top .title {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  background-image: linear-gradient(#0c255c, #040f27);
}

.zx-list .right .recommend .recommend-list li .recommend-bottom {
  font-size: 12px;
  color: #898989;
  margin-bottom: 23px;
}

>>> .el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

>>> .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Feature.vue